export const Статус = Object.freeze({
  Проведен: 'Проведен',

  Отгружен: 'Отгружен',
  НеОтгружен: 'Не отгружен',
  Получен: 'Получен',
  НеПолучен: 'Не получен',

  Оплачен: 'Оплачен',
  НеОплачен: 'Не оплачен',
  ЧастичноОплачен: 'Частично оплачен',
  ОтсрочкаОплата: 'Оплачен с отсрочкой',

  ЧастичноОтгружен: "Частично отгружен",
  ЧастичноПолучен: "Частично получен",

  ОжидаетПеремещения: 'Ожидает перемещения',
  
  ОплаченОжидаетОтгрузки: 'Оплачен, ожидает отгрузки',
  ОплаченПоставлен: 'Оплачен, поставлен',
  ЧастичноОплаченПоставлен: 'Частично оплачен, поставлен',
  ОтсрочкаОплатаПоставлен: 'Оплачен с отсрочкой, поставлен',
  ОплаченЧастичноПоставлен: 'Оплачен, частично поставлен',
  ЧастичноОплаченЧастичноПоставлен: 'Частично оплачен, частично поставлен',
  ОтсрочкаОплатаЧастичноПоставлен: 'Оплачен с отсрочкой, частично поставлен',
  ОплаченЧастичноОтгружен: 'Оплачен, частично отгружен',
  ЧастичноОплаченЧастичноОтгружен: 'Частично оплачен, частично отгружен',
  ОтсрочкаОплатаЧастичноОтгружен: 'Оплачен с отсрочкой, частично отгружен',
  ЧастичноОплаченОтгружен: 'Частично оплачен, отгружен',
  ОплаченОтгружен: 'Оплачен, отгружен',
  ОтсрочкаОплатаОтгружен: 'Оплачен с отсрочкой, отгружен',
  НеОбеспечена: 'Не обеспечена',
  НеОбеспечена_ВРаботе: 'Не обеспечена, в работе',
  Обеспечена: 'Обеспечена',
  Обеспечена_ВРаботе: 'Обеспечена, в работе',
  Черновик: 'Черновик',
  Архив: 'Архив',
});

export const documentStatusEnum = Object.freeze({
  Проведен: 'Проведен',
  Оплачен: 'Оплачен',
  НеОплачен: 'Не оплачен',
  ЧастичноОплачен: 'Частично оплачен',
  ОтсрочкаОплата: 'Оплачен с отсрочкой',
  ОжидаетПеремещения: 'Ожидает перемещения',
  Отгружен: 'Отгружен',
  ОплаченОжидаетОтгрузки: 'Оплачен, ожидает отгрузки',
  ОплаченПоставлен: 'Оплачен, поставлен',
  ЧастичноОплаченПоставлен: 'Частично оплачен, поставлен',
  ОтсрочкаОплатаПоставлен: 'Оплачен с отсрочкой, поставлен',
  ОплаченЧастичноПоставлен: 'Оплачен, частично поставлен',
  ЧастичноОплаченЧастичноПоставлен: 'Частично оплачен, частично поставлен',
  ОтсрочкаОплатаЧастичноПоставлен: 'Оплачен с отсрочкой, частично поставлен',
  ОплаченЧастичноОтгружен: 'Оплачен, частично отгружен',
  ЧастичноОплаченЧастичноОтгружен: 'Частично оплачен, частично отгружен',
  ОтсрочкаОплатаЧастичноОтгружен: 'Оплачен с отсрочкой, частично отгружен',
  ЧастичноОплаченОтгружен: 'Частично оплачен, отгружен',
  ОплаченОтгружен: 'Оплачен, отгружен',
  ОтсрочкаОплатаОтгружен: 'Оплачен с отсрочкой, отгружен',
  НеОбеспечена: 'Не обеспечена',
  НеОбеспечена_ВРаботе: 'Не обеспечена, в работе',
  Обеспечена: 'Обеспечена',
  Обеспечена_ВРаботе: 'Обеспечена, в работе',
  Черновик: 'Черновик',
  Архив: 'Архив',
});

export const UserRole = {
  Administrator: 'Administrator',
  Manager: 'Manager',
  Warehouseman: 'Warehouseman',
  Accountant: 'Accountant',
  User: 'User',
  Constructor: 'Constructor',
  ProductionManager: 'ProductionManager',
};

export const OperationDocumentType = {
  CREATE: 'RecordDocument',           // Оприходование
  WRITE_DOWN: 'WriteDownDocument',    // Списание
  MOVE: 'MoveDocument',               // Перемещение
  INVOICE_SUPPLIER: 'InvoiceSupp',    // Заказ поставщику
  COMING_INVOICE: 'ComingInvoiceSupp',// Приемка
  SHIPMENT_CUSTOMER: 'Shipment',      // Отгрузка
  ORDER_CUSTOMER: 'OrderCust',        // Заказ клиента
  ALL: 'All',                         // Все документы
  MANUFACTURE: 'ManufacturingDocument', // Производство
  SPECIFICATION: 'SpecificationDocument', // Спецификация
  COMPLECTATION: 'ComplectationDocument',  // Комплектация
  PAYMENT: 'Payment'  // Комплектация
};